<template>
  <v-flex xs12 sm3>
    <v-toolbar card dense class="header-element">
      <v-icon color="white">{{ icon }}</v-icon>
      <v-toolbar-title class="subheading">{{ listName }}</v-toolbar-title>
    </v-toolbar>
    <v-card max-height="400" class="scroll">
      <v-list two-line>
        <template v-for="(guest, i) in guests">
          <GuestDetails :key="guest.id" :guest="guest"></GuestDetails>
          <v-divider v-if="i !== guests.length-1" :key="i"></v-divider>
        </template>
      </v-list>
    </v-card>
  </v-flex>
</template>

<script>
import GuestDetails from '../components/GuestDetails'

export default {
  props: {
    listName: String,
    guests: Array,
    icon: String
  },

  components: {
    GuestDetails
  }
}
</script>

<style scoped>
.scroll {
  overflow-y: auto;
}
.header-element {
  background-color: #293968;
  color: white;
}
</style>
